module.exports = __webpack_public_path__ + "static/img/144.ad9be09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/144.png
// module id = +khq
// module chunks = 0